import axios from "axios";

// Prefer same-origin routing when the backend is proxied behind the same
// domain (e.g. custom domain in production). This avoids CORS entirely.
// Fallback: use REACT_APP_BACKEND_URL only when it differs from window origin.
function resolveApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return `${envUrl}/api`;
  try {
    if (!envUrl) return "/api";
    const envOrigin = new URL(envUrl).origin;
    // If the environment URL matches the current page origin, use relative path
    if (envOrigin === window.location.origin) return "/api";
    // If we're on a custom production domain (anything not matching the env preview),
    // prefer relative path because the same ingress also serves /api.
    const sameHostApi = `${window.location.origin}/api/sermons/stats`;
    // We can't synchronously check reachability; default to relative to avoid
    // cross-origin CORS failures in production. The ingress proxies /api -> backend.
    return "/api";
  } catch (_) {
    return `${envUrl}/api`;
  }
}

const API_BASE = resolveApiBase();
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = API_BASE;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Attach JWT from localStorage when present (fallback for environments that
// drop cross-site cookies, the server also sets an httpOnly cookie).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function clearAdminToken() {
  localStorage.removeItem("admin_token");
}

export function saveAdminToken(token) {
  localStorage.setItem("admin_token", token);
}

// Re-export the raw backend url in case legacy components need it
export { BACKEND_URL };
